/**
 * Декодирует RCDATA (картинка в base64 без префикса `data:`) в bitmap. Загрузки по URL нет, поэтому CSP `img-src`
 * не применяется, в отличие от `new Image().src = "data:..."`. Формат определяется по содержимому.
 */
export const rcdataToBitmap = async (rcdata: string) => {
  const bytes = Uint8Array.from(atob(rcdata), (char) => char.charCodeAt(0));
  return createImageBitmap(new Blob([bytes]));
};
